﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import { NotificationType, sendNotification } from '@tk/utilities/tk.notification';

export default class KDMZProductTile extends TKCustomElementFactory {
    constructor() {
        super();
    }

    connectedCallback(): void {
        this.registerClickListener();
    }

    registerClickListener() {
        this.pushListener({
            event: 'click',
            element: this,
            action: this.switchLayout.bind(this),
        });
    }

    switchLayout(event: Event): void {
        if (event.target.closest('[data-tile-img-url]')) {
            const url = event.target.closest('[data-tile-img-url]').getAttribute('data-tile-img-url');
            const payload = {};
            fetchRequest({
                requestURL: url,
                payload,
                resolveHandler: this.handleSuccessResponse.bind(this),
            });
        }
    }

    handleSuccessResponse(response) {
        if (response && response.success) {
            const html = response.dataAsHtml;
            if (html.trim() != '') {
                this.innerHTML = html;
            }
        }
    }

    handleErrorResponse(error) {
        console.error(error);
    }
}
